import React from 'react'
import { Grid, IconButton, Typography } from '@mui/material'
import { PickingRoute } from '../../../interfaces/Picking/Picking'
import { useAuth } from 'oidc-react'
import VisibilityIcon from '@mui/icons-material/Visibility'

import { EnumPickingStep } from '../pickingConfig'

import { PickingRouteContext } from '../../../components/Picking/PickingRouteContext'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'

interface PickingRouteHeaderProps {
  pickingRoute: PickingRoute | undefined
  username?: string
  position?: string
  logo?: string
}

export const NewPickingRouteHeader: React.FC<PickingRouteHeaderProps> = ({
  pickingRoute,
  position
}) => {
  const auth = useAuth()
  const route: PickingRoute = pickingRoute || new PickingRoute()

  const { setPreviousStep, step, setStep } =
    React.useContext(PickingRouteContext)

  const handleEyeIconClick = () => {
    setPreviousStep(step)
    setStep(EnumPickingStep.ViewPickingRouteDetailsProgress)
  }

  return (
    <Grid container direction='row' alignItems='center'>
      <Grid item xs={6}>
        <Typography variant='caption' display='block' gutterBottom>
          {auth.userData && auth.userData?.profile.name}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant='caption' display='block' gutterBottom>
          {route.startedAt?.toLocaleString()}
        </Typography>
      </Grid>
      <Grid
        container
        item
        xs={11}
        direction='column'
        alignItems='center'
        alignContent='center'
        justifyContent='center'
        style={{ textAlign: 'center' }}
      >
        <Typography variant='subtitle2'>
          {route.typePickingRouteId === eTypePickingRoute.RTV
            ? `# RTV${route.pickingRouteId}`
            : `# ${route.pickingRouteId}`}
        </Typography>

        {position && <Typography variant='h6'>{position}</Typography>}

        <Typography variant='subtitle2'>{route.zoneName}</Typography>
      </Grid>
      <Grid item xs={1}>
        <IconButton
          aria-label='delete'
          color='default'
          onClick={handleEyeIconClick}
        >
          <VisibilityIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}
